import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "KN_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ e.createElement("g", { mask: "url(#KN_svg__a)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0v24h32V0H0z",
      fill: "#C51918"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0v24L32 0H0z",
      fill: "#5EAA22"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M.636 27.952l.723.807.902-.602L38.52 3.954l1.2-.8-.962-1.074-5.321-5.936-.724-.807-.9.602-36.262 24.203-1.2.8.963 1.074 5.321 5.936z",
      fill: "#272727",
      stroke: "#FFD018",
      strokeWidth: 2.5
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.088 16.918L11 18.813l-.695-2.135-2.163-.687 1.802-1.1-.217-2.233 1.778 1.367 1.842-1.02-.517 2.273 1.478 1.7-2.22-.06zM22.088 10.365L21 12.26l-.695-2.134-2.163-.688 1.802-1.1-.217-2.233 1.778 1.367 1.842-1.02-.517 2.273 1.478 1.701-2.22-.06z",
      fill: "#F7FCFF"
    }
  ))
), a = t;
export {
  a as default
};
